// src/pages/Contact.jsx
import React from "react";
import Footer from "../components/Footer";
import { Mail } from "lucide-react";
//import contactbanner from "../images/contactbanner.jpg";

const Contact = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you! Your query has been recorded (frontend only for now).");
  };

  return (
    <>
      <main className="page contact-page px-[6%] py-16 min-h-[80vh] overflow-x-hidden">
        <section className="max-w-[1100px] mx-auto">
          {/* FULL-BLEED BANNER 
          //<div className="relative w-screen left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] mb-10 max-h-[360px] overflow-hidden">
            <img
              src={contactbanner}
              alt="DNA research illustration"
              className="w-full h-auto max-h-[360px] object-cover block"
            />
          </div>*/}

          <div className="mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-50 text-emerald-700 text-xs font-semibold mb-3">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
              Contact
            </div>
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2.5 rounded-full bg-emerald-100">
                <Mail className="w-5 h-5 text-emerald-700" />
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-slate-900">
                Contact{" "}
                <span className="text-emerald-700">Ori</span>
                <span className="text-purple-500">genomi</span> team
              </h1>
            </div>
            <p className="text-sm md:text-base leading-relaxed text-slate-700 max-w-3xl">
              For any feedback, queries, bug reports, or feature requests related
              to the Origenomi tool or database, feel free to reach out to us. We
              will try to respond at the earliest.
            </p>
          </div>

          {/* GRID: MAP + FORM */}
          <div className="grid grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)] gap-8 items-stretch">
            {/* MAP */}
            <div className="min-h-[320px]">
              <iframe
                title="BME-BT Academic Block, IIT Hyderabad"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15212.762931242283!2d78.1122807338824!3d17.593675487397146!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcbf748fc9a57bd%3A0x3e768972fc2b6e10!2sBME-BT%20Academic%20Block!5e0!3m2!1sen!2sin!4v1764004731168!5m2!1sen!2sin"
                className="w-full h-full min-h-[320px] rounded-xl border-0"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>

            {/* FORM */}
            <div className="bg-[#f3f5ff] p-8 rounded-xl shadow-[0_10px_30px_rgba(15,23,42,0.12)]">
              <form onSubmit={handleSubmit}>
                {/* First row */}
                <div className="grid grid-cols-2 gap-4 mb-4">
                  <input
                    type="text"
                    placeholder="Your Name"
                    required
                    className="contact-input"
                  />
                  <input
                    type="text"
                    placeholder="Your Surname"
                    required
                    className="contact-input"
                  />
                </div>

                <input
                  type="email"
                  placeholder="Your Email"
                  required
                  className="contact-input mb-4"
                />

                <input
                  type="text"
                  placeholder="Subject"
                  required
                  className="contact-input mb-4"
                />

                <textarea
                  placeholder="What is your doubt / message?"
                  rows="5"
                  required
                  className="contact-input mb-6 pt-3 resize-y"
                ></textarea>

                <button
                  type="submit"
                  className="w-full py-3 text-white font-semibold text-base rounded-lg bg-blue-700 shadow-md hover:bg-blue-800 transition"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Contact;
